import { FC } from "react";

import { ICommonDefaultDrawerProps } from "./common-default-drawer";
import { DrawerContentStyled, DrawerHeader, FormFooter } from "./drawer";

interface IFormDrawerProps extends Omit<ICommonDefaultDrawerProps, "Footer"> {
  onSaveClick: () => void;
  onCancelClick: () => void;
  footerSaveLabel?: string;
  isSaveDisabled?: boolean;
}

export const FormDrawer: FC<IFormDrawerProps> = ({
  onCloseDrawer,
  children,
  title,
  Header,
  onSaveClick,
  onCancelClick,
  isSaveDisabled,
  footerSaveLabel,
}) => {
  return (
    <>
      {Boolean(Header) && !title && Header}
      {title !== undefined && (
        <DrawerHeader onCloseDrawer={onCloseDrawer} title={title as string} />
      )}
      <DrawerContentStyled className="drawer-form">
        {children}
      </DrawerContentStyled>
      <FormFooter
        onSaveClick={onSaveClick}
        isSaveDisabled={isSaveDisabled}
        onCancelClick={onCancelClick}
        saveLabel={footerSaveLabel}
      />
    </>
  );
};
